import { apiErrorText } from "../utils/apiError"
import { useContext } from "react"
import styles from "./ErrorBanner.module.css"
import MainContext from "../common/MainContext"
import { AnimatePresence, motion } from "framer-motion"
import { ReactComponent as CloseIcon } from "../assets/images/icons/ic-close.svg"
import useWindowDimensions from "../common/hooks/useWindowDimensions"
import { ReactComponent as ErrorIcon } from "../assets/images/icons/ic-error.svg"

const ErrorBanner = ({ error }) => {

    const context = useContext(MainContext)
    const { width } = useWindowDimensions()
    const handleClose = (e) => {
        e.stopPropagation();
        context.setError(null)
    }


    return (
        <AnimatePresence>
            {context.error &&
                <motion.div
                    initial={{ x: width > 540 ? '100%' : 0, y: width > 540 ? 0 : '-200%' }}
                    animate={{ x: 0, y: 0 }}
                    exit={{ x: width > 540 ? '100%' : 0, y: width > 540 ? 0 : '-200%' }}
                    transition={{ duration: 0.18, ease: 'easeOut' }}
                    className={styles.container} role="alert" aria-atomic="true">
                    <span className={styles.icon} aria-hidden="true"><ErrorIcon /></span>
                    <div className={styles.info}>
                        <div className={styles.title}>
                            {apiErrorText(error?.title, "Attenzione")}
                        </div>
                        <div className={styles.body} tabIndex={0} role="region" aria-label="Dettaglio dell’errore">
                            {apiErrorText(error?.message)}
                        </div>
                    </div>
                    <button type="button" aria-label="Chiudi notifica di errore" className={styles.close} onClick={handleClose}>
                        <CloseIcon className={styles.closeIcon} />
                    </button>
                </motion.div>
            }
        </AnimatePresence>
    )
}

export default ErrorBanner